import classnames from 'classnames';
import * as React from 'react';

import * as digitalData from '@ao-internal/digital-data';

import { TaggingEventNames } from '../globals';

export interface MatchedResults {
	total: number;
	link?: string;
}

export interface ResultsProps {
	resultsData: MatchedResults;
}

export const Results: React.FC<
	ResultsProps & React.HTMLProps<HTMLDivElement>
> = ({ resultsData, className }) => {
	const { total, link } = resultsData;

	function handleLinkClick() {
		digitalData.sendBeacon(TaggingEventNames.interaction, {
			type: 'click',
			element: 'view-results',
			text: 'View All',
			url: link,
		});
	}

	return (
		<div
			data-testid="results"
			className={classnames(
				'shadow-3dp text-caption px-3 py-2 bg-white rounded-b-sm',
				className
			)}
		>
			{total === 1 ? (
				<div className="flex">
					<div>
						<strong>{total}</strong> Product found
					</div>
					{link && (
						<a
							className="text-link ml-auto"
							href={link}
							onClick={handleLinkClick}
						>
							View
						</a>
					)}
				</div>
			) : (
				<div className="flex">
					<div>
						<strong>{total}</strong> Products found
					</div>
					{total > 0 && (
						<React.Fragment>
							{link && (
								<a
									className="text-link ml-auto"
									href={link}
									onClick={handleLinkClick}
								>
									View all
								</a>
							)}
						</React.Fragment>
					)}
				</div>
			)}
		</div>
	);
};

export default Results;
